import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTeam = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.5 11C16.5707 11 18.25 9.32065 18.25 7.25C18.25 5.17852 16.5707 3.5 14.5 3.5C12.4294 3.5 10.75 5.17852 10.75 7.25C10.7426 9.3132 12.4103 10.9926 14.4735 11H14.5Z",
			stroke: "#8A94A6",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.5 20C10.9945 20 8 19.5256 8 17.6265C8 15.7273 10.9752 14 14.5 14C18.0055 14 21 15.7109 21 17.6092C21 19.5075 18.0248 20 14.5 20Z",
			stroke: "#8A94A6",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.4324 10.5006H8.40946C6.62099 10.4941 5.1753 9.0384 5.18175 7.24993C5.18175 5.45428 6.63748 3.99927 8.4324 3.99927M5.93243 19.3744C4.21009 19.1551 3 18.6272 3 17.5235C3 16.4183 4.20561 15.3827 5.93243 14.8556",
			stroke: "#8A94A6",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgTeam);
export { ForwardRef as ReactComponent };
